import sdl from '@jds/react-generated-sdl/JDSSelectorButton';
import type { JDSSelectorButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SelectorButtonProps } from '../logic';

const Component = (props: SelectorButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'primary',
    iconPosition = 'left',
    appearance = 'normal',
    size = 'medium',
    disabled = false,
    selected = false,
    stretch = false,
    ariaLabel = props.text?.toString(),
    _ariaPressed = props.selected?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      iconPosition,
      appearance,
      size,
      disabled,
      selected,
      stretch,
      ariaLabel,
      _ariaPressed,
      ...rest
    },
    'JDSSelectorButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SelectorButton = withLogic(Component) as React.ForwardRefExoticComponent<
  SelectorButtonProps & React.RefAttributes<HTMLButtonElement>
> & { slotName?: string };

SelectorButton.displayName = 'SelectorButton';
SelectorButton.slotName = 'jds_selector_button';

export { SelectorButton, type JDSSelectorButtonProps };
